module.exports = __webpack_public_path__ + "static/media/05-jobs.f24159a2.png";